import pimg1 from '../images/allimg/view/1.webp';
import pimg2 from '../images/allimg/view/2.webp';
import pimg3 from '../images/allimg/view/3.webp';
import pimg4 from '../images/allimg/view/4.webp';
import pimg5 from '../images/allimg/view/5.webp';
import pimg6 from '../images/allimg/view/6.webp';
import pimg7 from '../images/allimg/view/7.webp';
import pimg8 from '../images/allimg/view/8.webp';
import pimg9 from '../images/allimg/view/9.webp';
// import pimg10 from '../images/allimg/view/10.webp';
import pimg11 from '../images/allimg/view/V1.webp';
import pimg12 from '../images/allimg/view/V2.webp';
import pimg13 from '../images/allimg/view/V3.webp';
import pimg14 from '../images/allimg/view/V4.webp';
import ps1img1 from '../images/project-single/1.jpg';
import ps1img2 from '../images/project-single/2.jpg';
import ps1img3 from '../images/project-single/3.jpg';
import ps1img4 from '../images/project-single/4.jpg';
import ps1img5 from '../images/project-single/5.jpg';
import ps1img6 from '../images/project-single/6.jpg';
import ps1img7 from '../images/project-single/7.jpg';
import ps1img8 from '../images/project-single/8.jpg';
import ps1img9 from '../images/project-single/9.jpg';
import ps1img10 from '../images/project-single/10.jpg';
import psub1img1 from '../images/project-single/p1.jpg';
import psub1img2 from '../images/project-single/p2.jpg';

const View = [
    {
        Id: '1',
        pImg: pimg1,
        ps1img: ps1img1,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'WHITE HOUSE',
        subTitle: 'Luxury Villa in Udupi',
    },
    {
        Id: '11',
        pImg: pimg11,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '2',
        pImg: pimg2,
        ps1img: ps1img2,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'GARDEN VILLA',
        subTitle: 'Garden Paradise',
    },
    {
        Id: '3',
        pImg: pimg3,
        ps1img: ps1img3,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'COTTAGE HOUSE',
        subTitle: 'Charming Countryside Cottage',
    },
    {
        Id: '4',
        pImg: pimg4,
        ps1img: ps1img4,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'HILL TOP VILLA',
        subTitle: 'Spectacular Hilltop Views',
    },
    {
        Id: '5',
        pImg: pimg5,
        ps1img: ps1img5,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'SUNRISE HOME',
        subTitle: 'Enjoy Morning Bliss',
    },
    {
        Id: '6',
        pImg: pimg6,
        ps1img: ps1img6,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'CHALET LABONNE',
        subTitle: 'Rustic Chalet Escape',
    },
    {
        Id: '7',
        pImg: pimg7,
        ps1img: ps1img7,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'VIEWPOINT OASIS',
        subTitle: 'Breathtaking Views',
    },
    {
        Id: '8',
        pImg: pimg8,
        ps1img: ps1img8,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'INTERIOR',
        subTitle: 'Modern Interior Design',
    },
    {
        Id: '9',
        pImg: pimg9,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
      
    {
        Id: '12',
        pImg: pimg12,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    
    {
        Id: '14',
        pImg: pimg14,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    
];

export default View;
